import React, { useCallback, useMemo } from 'react';
import excelIcon from '@/pages/aigc/assets/svg/excel.svg';
import downloadIcon from '@/pages/aigc/assets/svg/download.svg';
import { useDownloadNotification } from './hooks';
import { handleDownload } from './_utils';
import type { IDownloadLinkProps } from './_type';
import EllipsisHover from '@/pages/aigc/components/EllipsisHover';
import './index.scss';

/**
 * 下载链接组件
 * 用于在 format === 'file' 或数据量过大时显示下载入口
 * 点击直接下载，复用下载表头和表格内容格式化逻辑
 */

const DownloadLink: React.FC<IDownloadLinkProps> = ({
  formattedData,
  rawData = [],
  downloadTitle,
  filterVal = {},
  enableNotification = false,
}) => {
  // 生成文件名
  const fileName = useMemo(() => {
    return downloadTitle || formattedData.title || 'download';
  }, [downloadTitle, formattedData.title]);

  // 使用下载通知 Hook（根据 enableNotification 决定是否启用）
  const { setNoticeStatus } = useDownloadNotification(
    '',
    enableNotification
  );

  const handleClick = useCallback(async (): Promise<void> => {
    await handleDownload({
      formattedData,
      rawData,
      downloadTitle,
      filterVal,
      fileName,
      setNoticeStatus: enableNotification ? setNoticeStatus : undefined,
      enableNotification,
    });
  }, [
    formattedData,
    rawData,
    downloadTitle,
    filterVal,
    fileName,
    setNoticeStatus,
    enableNotification,
  ]);

  return (
    <div className="dba-download-link-container">
      <div
        className="dba-download-link-item"
        onClick={() => {
          handleClick().catch((error) => {
            console.error('下载失败:', error);
            if (enableNotification) {
              setNoticeStatus('error');
            }
          });
        }}
      >
        <img src={excelIcon} alt="Excel" className="dba-download-link-excel-icon" />
        <EllipsisHover
          className="dba-download-link-filename-ellipsis"
          text={`${fileName}.xlsx`}
          maxLines={2}
        />
        <img src={downloadIcon} alt="Download" className="dba-download-link-download-icon" />
      </div>
    </div>
  );
};

export default DownloadLink;

